module.exports = {
  props: {
    field: {
      type: Object,
      required: true,
    },
    errors: {
      required: false,
      default: function () {
        return []
      },
    },
    initialState: {
      required: false,
      default: null,
    },
    formLocation: {
      required: false,
      type: String,
      default: '',
    },
    unionSlug: {
      required: false,
      type: String,
      default: '',
    },
    flatPickerDateFormat: {
      required: true,
      type: String,
    },
    isDisabled : {
      required: false,
      type: Boolean,
      default : false,
    },
  },
  data: function () {
    return {
      value: this.initialState,
    }
  },
  computed: {
    rules() {
      return this.field.rules.data
    },
    errorMessage() {
      return Array.isArray(this.errors) ? this.errors[0] : this.errors
    },
    fieldStyling() {
      switch (this.formLocation) {
        case 'request-access':
          return ''
        default:
          return 'field'
      }
    },
    hasUnionSlug() {
      return this.unionSlug.length > 0
    },
  },
  watch: {
    value(updated) {
      this.$emit('inputChanged', {
        field: this.field.attributes.slug,
        value: updated,
      })
    },
  },
}